import { TbLink } from "solid-icons/tb";
import { type JSX, Show } from "solid-js";
import { Dynamic } from "solid-js/web";
import { slugify } from "../../../scripts/changelog/sections.mjs";

export const copyLink = (event: MouseEvent) => {
  const href = (event.currentTarget as HTMLAnchorElement).href;
  navigator.clipboard?.writeText(href).catch(() => {});
};

// Every `##` section gets an id and a hover link, so the what's-new popover and the
// desktop dialog can land on `/changelog/<slug>#<section>`, the blog's on-this-page list
// can jump to a section, and a reader can copy the link. The slug is the one the build
// computes from the source with the same function, so the anchors those surfaces link to
// are the ones rendered here. A heading that is not plain text gets no anchor rather
// than a wrong one.
export function SectionHeading(props: { children?: JSX.Element; level?: 3 }) {
  const slug = () => (typeof props.children === "string" ? slugify(props.children) : undefined);
  return (
    <Dynamic component={props.level === 3 ? "h3" : "h2"} id={slug()} class="group/heading scroll-mt-24">
      {props.children}
      <Show when={slug()}>
        {(id) => (
          <a
            href={`#${id()}`}
            onClick={copyLink}
            aria-label="Copy link to this section"
            class="section-anchor ms-[0.3em] inline-block rounded-sm align-middle text-secondary-text opacity-0 transition-opacity group-hover/heading:opacity-100 hover:text-primary-text focus-visible:opacity-100 focus-visible:ring-2 focus-visible:ring-brand focus-visible:outline-none"
          >
            <TbLink class="size-[0.6em]" aria-hidden="true" />
          </a>
        )}
      </Show>
    </Dynamic>
  );
}
